import { usePlatformContext, usePlatformFeatureFlag } from '@datassential/platform-ui-lib';
import { useData } from '@hooks/useData';
import { PermissionLevelEnum } from '@models/PermissionSection';
import { getMacs } from '@apiHooks/useMacs';
import { getMacsListObsolete } from '@apiHooks/useMacsListObsolete';
import { MAC_NEW_ORIGIN_FLAG } from '@apiHooks/useMacs.constants';

/**
 * Waits for user info so the flag is settled, then asks the endpoint the flag points to.
 * Drop the legacy branch when the Obsolete MAC list is removed.
 */
async function getMacsPermissionLevel(isUserInfoLoaded: boolean, isNewOrigin: boolean): Promise<PermissionLevelEnum> {
    if (!isUserInfoLoaded) return PermissionLevelEnum.Full;

    const { permissionLevel } = isNewOrigin ? await getMacs() : await getMacsListObsolete();

    return permissionLevel;
}

export function useMacsPermissionLevel() {
    const { isUserInfoLoaded } = usePlatformContext();
    const isNewOrigin = usePlatformFeatureFlag(MAC_NEW_ORIGIN_FLAG);

    return useData(PermissionLevelEnum.Full, getMacsPermissionLevel, isUserInfoLoaded, isNewOrigin);
}
